import React, { useEffect, useState } from "react";
import * as S from "./ToolbarContentManagement.style";
import FlorenzButton from "../../../../florenzComponents/florenzButton";
import FlorenzSearchInput from "../../../../florenzComponents/florenceSearchInput";
import { useTranslation } from "react-i18next";

function ToolbarContentManagement ({
  setInputText
}) {  

  const {t, i18n: { language }} = useTranslation("global");  

  return (
    <S.ToolbarContentManagement>
      <div className="toolbar">
        <div className="toolbar__left">
          <div className="toolbar-button">
            {/* <FlorenzButton
              typeStyle={"outline"}
              size="s"
              icon="zaia-i-refresh"
              text={"Filtrar por programa"}
              widthComplete={true}
              onClick={() => {
                
              }}
            /> */}
          </div>
          {/* <div className="buttons-separator"></div> */}
          <div className="toolbar-button">
            {/* <FlorenzButton
              typeStyle={"outline"}
              size="s"
              icon="zaia-i-refresh"
              text={"Categoría"}
              widthComplete={true}
              onClick={() => {
                
              }}
            /> */}
          </div>
        </div>
        <div className="toolbar__right">
          <div className="searcher-container">
            <FlorenzSearchInput
              getText={setInputText}
              placeholder={t('globally.searchNameSeries')}
              forWhiteBackgroud={false}
            />
          </div>
        </div>
      </div>
    </S.ToolbarContentManagement>
  )

}

export default ToolbarContentManagement;
